import { Reveal } from "@/components/Reveal";
import { ScrambleText } from "@/components/ScrambleText";

const CARDS = [
  {
    n: "1",
    title: "Physical Unclonable Function",
    body: "A device identity derived from silicon physics — physically infeasible to duplicate or emulate.",
  },
  {
    n: "2",
    title: "Cryptographic Binding",
    body: "Every recording is signed at the moment of capture, before it can ever leave the device.",
  },
  {
    n: "3",
    title: "Perceptual Watermarking",
    body: "Proof of origin woven into the audio itself. Inaudible. Survives compression and transcoding. Machine-readable.",
  },
];

export default function Solution() {
  return (
    <section id="solution" data-testid="solution-section" className="px-6 py-28 sm:px-10 lg:px-20 lg:py-36">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.35em] text-[#C4A24C]"><ScrambleText text="02 / The Solution" /></p>
        </Reveal>
        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {CARDS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12} className="h-full">
              <div
                data-testid={`solution-card-${c.n}`}
                className="h-full border border-white/5 border-t-[#C4A24C] bg-[#0C0E15] p-10 transition-colors duration-500 hover:border-[#C4A24C] lg:p-12"
              >
                <div className="font-serif text-5xl text-[#C4A24C]">{c.n}</div>
                <h3 className="mt-10 font-serif text-2xl text-[#E4E5EA]">{c.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-[#E4E5EA]/70">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
